module.exports = __webpack_public_path__ + "img/front_angle.9f0b2a94.jpg";